/**
 * How collapsed task rows lay out title and property badges.
 *
 * - `'single'`: classic one-line layout (attention/start before the title,
 *   tags after it, duration/deadline on the right) with the static pill
 *   rules — no measurement.
 * - `'adaptive'`: one line while title + badges fit, two lines (title row +
 *   properties row) when they don't — measured per row (useCollapsedRowFit),
 *   with tags expanding/summarizing responsively.
 *
 * A future "always show tasks as two lines" user setting adds an `'always'`
 * mode here — consumers (TaskEntry, the `task-entry--two-line` styles) never
 * need to change.
 */
export type TaskRowLayoutMode = 'single' | 'adaptive'

/**
 * Decides the row layout mode. Adaptive everywhere (full and list window
 * mode alike) — this hook stays the single switch for the future setting.
 */
export function useTaskRowLayout(): { rowLayoutMode: TaskRowLayoutMode } {
  return { rowLayoutMode: 'adaptive' }
}
